import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import authReducer from './auth';
import { INITIALIZE_APP_ACTION } from '../actions';

export const gaSettingsReducer = (state = {}, { type, payload }) => {
    if (type === INITIALIZE_APP_ACTION) {
        return {
            ...state,
            ...payload.gaSettings,
        };
    }

    return state;
};

const reducers = {
    form: formReducer,
    routing: routerReducer,
    authentication: authReducer,
    gaSettings: gaSettingsReducer,
};

export const rootReducer = combineReducers({
    ...reducers,
});
